<div class="overarching">
    <div *ngIf="isLoading" class="loading"><mat-spinner></mat-spinner></div>
    <div *ngIf="dataset.data.length === 0 && !isLoading" class="no-data-message">
        <mat-icon>cloud_off</mat-icon>
        <div>No tickets match the filter</div>
    </div>
    <canvas #chartCanvas [hidden]="isLoading"></canvas>
</div>